import { render, staticRenderFns } from "./choice_app.vue?vue&type=template&id=5f4c61b6&scoped=true&"
import script from "./choice_app.vue?vue&type=script&lang=js&"
export * from "./choice_app.vue?vue&type=script&lang=js&"
import style0 from "./choice_app.vue?vue&type=style&index=0&id=5f4c61b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4c61b6",
  null
  
)

export default component.exports